export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["魔法词是额外的安全设置。"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["如果启用了魔法词，每次授权时，系统将要求您输入魔法词中的一些字符（按其序号）。"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["魔法词"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["要求魔法词"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["进入办公室时询问"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通过商户付款时询问"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用卡时"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保存"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["魔法词"])},
  "hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["额外保护：登录时，系统会要求您输入密码词中的几个字符以验证您的身份。"])}
}